export default __webpack_public_path__ + "static/media/note_agenzie.9727c717.less";